import { render, staticRenderFns } from "./TModal.vue?vue&type=template&id=ff4a845a&scoped=true&"
import script from "./TModal.vue?vue&type=script&lang=js&"
export * from "./TModal.vue?vue&type=script&lang=js&"
import style0 from "./TModal.vue?vue&type=style&index=0&id=ff4a845a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4a845a",
  null
  
)

export default component.exports